module.exports = __webpack_public_path__ + "media/images/favicon-1555eedaf636d83865751d3d139ef9f5.ico";